import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import axios from 'src/app/Service/axios';

import * as XLSX from 'xlsx';

import { Meta } from '@angular/platform-browser';

declare let $: any;

@Component({

  selector: 'app-taxilon-debit-credit',

  templateUrl: './taxilon-debit-credit.component.html',

  styleUrls: ['./taxilon-debit-credit.component.css']

})

export class TaxilonDebitCreditComponent implements OnInit {

  lst_Debit_Credit: any[] = [];

  lst_Search: any[] = [];

  iCredit: number = 0;

  iDebit: number = 0;

  editMode: boolean = false;

  bEmdadRan: boolean = false;

  webAppName = (<any>window).webAppName;

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strUnitID: new FormControl(''),

    strFullName: new FormControl(''),

    strMobile: new FormControl(''),

  })

  mdl_Request: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iTaxiLon_DebitCredit: new FormControl(''),

    strUnitID: new FormControl(''),

    strDate: new FormControl('', Validators.required),

    strDetail: new FormControl('', Validators.required),

    iCredit: new FormControl('0'),

    iDebit: new FormControl('0'),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private metaService: Meta

  ) { }

  ngOnInit(): void {

    this._otherService.setTitle(`${this.webAppName} | بدهکاری/بستانکاری رانندگان تاکسی لون`);

    this.route.parent?.url.subscribe((segment: any) => {

      this.bEmdadRan = segment[0].path == 'taxiLon' ? false : true;


    })

  }

  ngOnDestroy() {

    this._otherService.setTitle(this.webAppName)

  }

  filter_list(val: any) {

    this.lst_Debit_Credit = this.lst_Search.filter((el: any) => {

      return el?.strFullName?.includes(val.value) || el.strMobile.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Debit_Credit = this.lst_Search;

    }

  }

  async search_Driver() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_DebitCredit_ORG_DriverReport`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Debit_Credit = res;

    this.iCredit = 0;

    this.iDebit = 0;

    res.forEach((el: any) => {

      this.iCredit += el.iCredit;

      this.iDebit += el.iDebit;

    })

    this.lst_Search = res;

  }

  async remove_item(item: any, index: number) {

    $.confirm({

      title: `آیا از حذف اطلاعات دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {

              iTaxiLon_DebitCredit: item.iTaxiLon_DebitCredit,

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

            }

            this._otherService.Showspinner();

            const resp = await axios.post(`TaxiLon_DebitCredit_Delete`, model);

            this._otherService.nonespinner();

            let res = JSON.parse(resp.data);

            if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

            this.lst_Debit_Credit.splice(index, 1);

            return this._tooltip.showSuccess('اطلاعات با موفقیت حذف شد');

          }

        },

        cancel: {

          text: "لغو",


        }

      }

    });

  }

  exportExcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'بدهکاری/بستانکاری رانندگان تاکسی لون.xlsx');
  }

  highlightText(text: string, searchTerm: string) {

    if (!searchTerm) {

      return text;

    }

    const regex = new RegExp(searchTerm, 'gi');

    return text?.replace(regex, (match: string) => {

      return `<mark>${match}</mark>`;

    });

  }

  add_Request(item: any, editMode = false) {

    if (!editMode) {

      this.mdl_Request.patchValue({

        strUnitID: item.strUnitID,

        iTaxiLon_DebitCredit: '',

        strDate: '',

        strDetail: '',

        iCredit: '',

        iDebit: '',

      })

      this.editMode = false;

      $('#Request_Modal').modal('show');

    }

    else {

      this.mdl_Request.patchValue({

        strUnitID: item.strUnitID,

        iTaxiLon_DebitCredit: item.iTaxiLon_DebitCredit,

        strDate: item.strDate,

        strDetail: item.strDetail,

        iCredit: item.iCredit.toLocaleString(),

        iDebit: item.iDebit.toLocaleString(),

      })

      this.editMode = true;

      $('#Request_Modal').modal('show');

    }

  }

  async submit_Request() {

    let model = this.mdl_Request.value;

    if (this.mdl_Request.invalid) return this._tooltip.showError('ورود تاریخ و توضیحات الزامی می باشد');

    if ((model.iDebit == 0 || model.iDebit == '') && (model.iCredit == 0 || model.iCredit == '')) {

      return this._tooltip.showError('بدهکاری یا بستانکاری را وارد کنید');

    }

    else {

      if (model.iDebit?.toString().includes(',')) {

        model.iDebit = model.iDebit.replace(/,/g, '');

      }

      if (model.iCredit?.toString().includes(',')) {

        model.iCredit = model.iCredit.replace(/,/g, '');

      }

      if (!this.editMode) {

        this._otherService.Showspinner();

        let res = JSON.parse((await axios.post(`TaxiLon_DebitCredit_Save`, this._otherService.stringNumberToNumber(model))).data.toString());

        this._otherService.nonespinner();

        if (res.iResult == 0) return this._tooltip.showError(res.strError);

        this.lst_Debit_Credit.push(res[0]);

        this._tooltip.showSuccess('عملیات با موفقیت انجام شد');

        $('#Request_Modal').modal('hide');

      }

      if (this.editMode) {

        $.confirm({

          title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

          content: '',

          type: 'blue',

          buttons: {

            ok: {

              text: "ویرایش",

              btnClass: 'btn-primary',

              keys: ['enter'],

              action: async () => {

                this._otherService.Showspinner();

                let res = JSON.parse((await axios.post(`TaxiLon_DebitCredit_Edit`, this._otherService.stringNumberToNumber(model))).data.toString());

                this._otherService.nonespinner();

                if (res.iResult == 0) return this._tooltip.showError(res.strError);

                this.lst_Debit_Credit.push(res[0]);

                this._tooltip.showSuccess('عملیات با موفقیت انجام شد');

                $('#Request_Modal').modal('hide');


              }

            },

            cancel: {

              text: "لغو",

            }

          }

        });

      }

    }


  }


}
